import {
  type DependencyList,
  useCallback,
  type EffectCallback,
  useEffect,
} from "react"
import {
  useFocusEffect,
  useGlobalSearchParams,
  usePathname,
  useSegments,
} from "expo-router"
import { segment } from "./client.web"
import { FullStory, isInitialized } from "@fullstory/browser"
import { init as initFullStory } from "@/hooks/fullStory"
import { getScreenName } from "@/constants/Screens"

export const useRootScreenTracking = () => {
  const segments = useSegments()
  const pathname = usePathname()
  const params = useGlobalSearchParams()
  const screenName = segments.join("-") || "index"

  useEffect(() => {
    // TODO: Revist how we name and track screens for the purpose of metrics
    void segment.page(screenName, {
      pathname,
      params,
    })

    initFullStory()

    if (isInitialized()) {
      FullStory("setProperties", {
        type: "page",
        properties: {
          pageName: getScreenName(screenName),
        },
      })
    }
  }, [screenName, pathname, params])
}

export const AppAnalyticsProvider = ({ children }: React.PropsWithChildren) => {
  return <>{children}</>
}

export const useViewedCallback = (
  viewedCallback: EffectCallback,
  deps: DependencyList = []
) => {
  useFocusEffect(useCallback(viewedCallback, deps))
}

export const forceAnonId = async (anonId: string) => {
  await segment.setAnonymousId(anonId)
}
